import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Contrato y posesión", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "contract-type"
}, "Tipo de contrato", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "contract-number"
}, "Número de contrato", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "date-first-act"
}, "Fecha 1ra acta de posesión", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "first-act"
}, "1ra acta de posesión", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "date-last-act"
}, "Fecha última acta de posesión", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "last-act"
}, "Última acta de posesión", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "first-decree"
}, "Primer decreto de posesión", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "last-decree"
}, "Último decreto de posesión", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "resolution"
}, "Resolución", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "resolution-date"
}, "Fecha de resolución", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Asignación institucional", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "resolution-date"
}, "Jornada asignada", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "resolution-date"
}, "Sede principal", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-school-level"
}, "Nivel escolar", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-education-level"
}, "Nivel educativo aprobado", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-teaching-area"
}, "Área técnica", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_input, {
                  id: "contract-type",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ContractType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('ContractType', val)),
                  placeholder: "Ej: Fijo, Indefinido, Temporal",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_b_form_input, {
                  id: "contract-number",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ContractNumber,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('ContractNumber', val)),
                  placeholder: "Ingrese el número de contrato",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_b_form_input, {
                  id: "date-first-act",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.DateFirstActPossession,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('DateFirstActPossession', val)),
                  type: "date"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_b_form_input, {
                  id: "first-act",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FirstActPossession,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('FirstActPossession', val)),
                  placeholder: "Ingrese el número o referencia del acta",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_b_form_input, {
                  id: "date-last-act",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.DateLastActPossession,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('DateLastActPossession', val)),
                  type: "date"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_b_form_input, {
                  id: "last-act",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.LastActPossession,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('LastActPossession', val)),
                  placeholder: "Ingrese el número o referencia del acta",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_b_form_input, {
                  id: "first-decree",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FirstDecreePossession,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('FirstDecreePossession', val)),
                  placeholder: "Ingrese el número o referencia del decreto",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_b_form_input, {
                  id: "last-decree",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.LastDecreePossession,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('LastDecreePossession', val)),
                  placeholder: "Ingrese el número o referencia del decreto",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_b_form_input, {
                  id: "resolution",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Resolution,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = val => _ctx.updateField('Resolution', val)),
                  placeholder: "Ingrese el número de resolución",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_11,
                _createVNode(_component_b_form_input, {
                  id: "resolution-date",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ResolutionDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.updateField('ResolutionDate', val)),
                  type: "date"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_12,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_b_form_select, {
                  id: "input-doc-type",
                  class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.JourneyId }]),
                  modelValue: _ctx.recordProxy.JourneyId,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = val => _ctx.updateField('JourneyId', val)),
                  options: _ctx.Journeys,
                  "value-field": "Id",
                  "text-field": "Description",
                  required: ""
                }, null, 8, ["modelValue", "options", "class"]),
                _createVNode(_component_b_form_invalid_feedback, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Campo requerido")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_14,
                _createVNode(_component_b_form_select, {
                  id: "input-doc-type",
                  class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.HeadquarterId }]),
                  modelValue: _ctx.recordProxy.HeadquarterId,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = val => _ctx.updateField('HeadquarterId', val)),
                  options: _ctx.Headquarters,
                  "value-field": "Id",
                  "text-field": "Description",
                  required: ""
                }, null, 8, ["modelValue", "options", "class"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_15,
                _createVNode(_component_b_form_select, {
                  id: "input-school-level",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.SchoolLevelId,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = val => _ctx.updateField('SchoolLevelId', _ctx.toNumber(val))),
                  options: _ctx.SchoolLevels,
                  "value-field": "Id",
                  "text-field": "Name"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_16,
                _createVNode(_component_b_form_select, {
                  id: "input-education-level",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.LevelEducationApprovedId,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = val => _ctx.updateField('LevelEducationApprovedId', _ctx.toNumber(val))),
                  options: _ctx.EducationLevels,
                  "value-field": "Id",
                  "text-field": "Name"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          cols: "6",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_17,
                _createVNode(_component_b_form_select, {
                  id: "input-teaching-area",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.TeachingAreaTechnicalId,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = val => _ctx.updateField('TeachingAreaTechnicalId', _ctx.toNumber(val))),
                  options: _ctx.TeachingAreas,
                  "value-field": "Id",
                  "text-field": "Name"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}